module.exports = __webpack_public_path__ + "img/452.f49387cb.png";